'use client'

import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

interface LogoProps {
  alt?: string
  width?: number
  height?: number
  className?: string
}

export function Logo({ alt = 'Logo', width = 60, height = 40, className }: LogoProps) {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch by only rendering after mount
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    // Return a placeholder with the same dimensions during SSR
    return (
      <div 
        className={`bg-muted animate-pulse rounded ${className}`}
        style={{ width, height }}
      />
    )
  }

  // Use resolvedTheme to get the actual theme (system preference resolved)
  const isDark = resolvedTheme === 'dark'
  const fillColor = isDark ? '#ffffff' : '#000000'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 540 339"
      version="1.1"
      className={className}
      aria-label={alt}
    >
      <path 
        d="M 0 109.209 C -0 230.583, -0.186 226.697, 6.585 246.951 C 20.111 287.411, 52.691 319.707, 92.745 332.360 C 108.461 337.324, 116.271 338.442, 135 338.404 C 159.916 338.355, 175.527 334.785, 196.387 324.368 C 227.590 308.787, 252.603 279.785, 263.420 246.647 C 268.689 230.507, 269.165 226.429, 269.968 190.500 C 270.530 165.383, 271.143 154.671, 272.314 149.500 C 279.223 119.009, 297.833 94.542, 324.573 80.796 C 353.842 65.751, 385.971 65.440, 415.477 79.918 C 469.919 106.632, 488.030 176.346, 453.687 227 C 449.223 233.584, 436.414 246.558, 429.444 251.556 C 421.376 257.342, 406.363 264.473, 396.500 267.206 C 389.591 269.120, 386.045 269.420, 370.500 269.406 C 353.762 269.391, 351.869 269.197, 343.500 266.650 C 338.550 265.143, 330.769 262.074, 326.209 259.829 C 321.649 257.585, 317.747 255.919, 317.539 256.128 C 315.979 257.688, 286.334 315.692, 286.747 316.377 C 287.692 317.946, 307.261 326.812, 316.836 330.009 C 355.606 342.954, 397.654 341.557, 435.500 326.065 C 482.081 306.999, 519.695 264.903, 533.401 216.500 C 536.127 206.873, 538.862 192.352, 539.217 185.619 C 539.337 183.354, 539.689 190.275, 540 201 C 540.311 211.725, 540.555 170.775, 540.542 110 C 540.519 2.626, 540.504 1.749, 540.009 79 C 539.728 122.909, 539.171 155.044, 538.765 150.781 C 534.999 111.207, 513.069 69.223, 482.369 42.814 C 450.223 15.162, 412.841 1.070, 371.500 1.021 C 355.383 1.002, 343.759 2.376, 329.347 6.005 C 270.369 20.856, 223.158 67.386, 207.543 126.053 C 203.254 142.167, 202.038 154.285, 202.018 181.119 C 201.998 208.034, 200.863 218.005, 196.498 229.602 C 188.736 250.224, 173.257 263.914, 152.476 268.538 C 141.032 271.083, 121.261 270.201, 110.422 266.661 C 100.625 263.460, 90.027 256.306, 84.001 248.826 C 77.961 241.328, 72.144 228.451, 69.912 217.636 C 68.136 209.031, 68.026 202.474, 68.013 104.750 L 68 1 58.162 1 C 52.751 1, 37.451 0.703, 24.162 0.340 L 0 -0.320 0 109.209 M 0.483 111 C 0.483 171.775, 0.603 196.637, 0.750 166.250 C 0.897 135.862, 0.897 86.137, 0.750 55.750 C 0.603 25.362, 0.483 50.225, 0.483 111" 
        stroke="none" 
        fill={fillColor} 
        fillRule="evenodd"
      />
    </svg>
  )
} 